// removed by extract-text-webpack-plugin
module.exports = {"tabs":"tabs--tabs--37CwCdpP","tab":"tabs--tab--4xpD2vJB","tab-label":"tabs--tab-label--1NzNulfB","tabLabel":"tabs--tab-label--1NzNulfB","isSelected":"tabs--isSelected--3WX47a28","isDisabled":"tabs--isDisabled--3PJ-uPj9","slide":"tabs--slide--1wWPVHcW"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Tabs/tabs.scss
// module id = 604
// module chunks = 0